import { schema } from 'normalizr';

// eslint-disable-next-line import/prefer-default-export
export const visitNoteTemplateSchema = new schema.Entity('visitNoteTemplates');
